import { DeleteOutlined, EditOutlined, PlusOutlined } from "@ant-design/icons";
import { Button, Modal, Space, Table, Tooltip, message } from "antd";
import axios from "axios";
import { PRIMARY_RED } from "constants/colors";
import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Card, CardBody, Col, Row } from "reactstrap";
import { setBreadcrumbItems } from "../../store/actions";

const Collateral = (props) => {
  const [collateral, setCollateral] = useState([]);
  const navigate = useNavigate();
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [selectedCollateral, setSelectedCollateral] = useState(null);
  const authUser = JSON.parse(localStorage.getItem("authUser"));
  const token = authUser?.token;
  const breadcrumbItems = [
    { title: "Form & Collateral", link: "#" },
    { title: "Collateral", link: "#" },
  ];

  useEffect(() => {
    props.setBreadcrumbItems("Collateral", breadcrumbItems);
    fetchCollateral();
  }, []);

  const fetchCollateral = async () => {
    try {
      const response = await axios.get(`${process.env.REACT_APP_API_BASEURL}/collateral`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setCollateral(response.data);
    } catch (err) {
      message.error("Failed to load forms");
    }
  };

  const handleDelete = async (collateralId, collateralName) => {
    try {
      await axios.delete(`${process.env.REACT_APP_API_BASEURL}/collateral/${collateralId}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      message.success(`Deleted collateral: ${collateralName}`);
      fetchCollateral();
    } catch (err) {
      message.error("Failed to delete collateral");
    }
  };

  const handleViewPDF = (base64String) => {
    const pdfWindow = window.open();
    pdfWindow.document.write(
      `<iframe width='100%' height='100%' src='data:application/pdf;base64,${base64String}'></iframe>`
    );
  };

  const columns = [
    { title: "Collateral Name", dataIndex: "collateralName", key: "collateralName" },
    { title: "Description", dataIndex: "collateralDescription", key: "collateralDescription" },

    {
      title: "PDF Link",
      dataIndex: "collateralPdfUrl",
      key: "collateralPdfUrl",
      align: "center",
      render: (base64String) => (
        <Tooltip title="View PDF">
          <Button
            type="text"
            style={{ color: PRIMARY_RED }}
            onClick={() => handleViewPDF(base64String)}
          >
            View PDF
          </Button>
        </Tooltip>
      ),
    },
    {
      title: "Actions",
      key: "actions",
      align: "center",
      render: (_, record) => (
        <Space>
          <Tooltip title="Edit">
            <Button
              type="text"
              icon={<EditOutlined />}
              onClick={() => navigate(`/edit-collaterals/${record._id}`)}
            />
          </Tooltip>
          <Tooltip title="Delete">

            <Button
              type="text"
              icon={<DeleteOutlined />}
              style={{ color: PRIMARY_RED }}
              onClick={() => {
                setSelectedCollateral(record);
                setIsModalVisible(true);
              }}
            />
          </Tooltip>
        </Space>
      ),
    },
  ];

  return (
    <React.Fragment>
      <Row>
        <Col xs="12">
          <div className="d-flex justify-content-end align-items-center mb-4">
            <Button type="primary" icon={<PlusOutlined />} style={{ backgroundColor: PRIMARY_RED }} onClick={() => navigate("/add-collaterals")}>
              Add Collateral
            </Button>
          </div>
          <Card>
            <Modal
              title="Delete form"
              visible={isModalVisible}
              onCancel={() => setIsModalVisible(false)}
              footer={[
                <Button key="cancel" onClick={() => setIsModalVisible(false)} style={{ backgroundColor: "#6c757d", color: "white" }}>
                  Close
                </Button>,
                <Button
                  key="delete"
                  type="primary"
                  style={{ backgroundColor: PRIMARY_RED }}
                  icon={<DeleteOutlined />}
                  onClick={() => {
                    handleDelete(selectedCollateral._id, selectedCollateral.collateralName);
                    setIsModalVisible(false);
                  }}
                >
                  Delete
                </Button>,
              ]}
            >
              <p>Are you sure you want to delete <strong>{selectedCollateral?.collateralName}</strong> collateral?</p>
            </Modal>
            <CardBody>
              <Table columns={columns} dataSource={collateral} rowKey="_id" pagination={false} />
            </CardBody>
          </Card>
        </Col>
      </Row>
    </React.Fragment>
  );
};

export default connect(null, { setBreadcrumbItems })(Collateral);
